import { OpeningChapter } from "@/components/presentation/OpeningChapter";
import { NarrativeChapter } from "@/components/presentation/NarrativeChapter";

/**
 * Thin shell that decides which chapter renderer to mount.
 *
 *   • Chapters with `custom` opt into a bespoke renderer (e.g. the Opening).
 *   • Every other chapter flows through the Narrative Chapter Engine, which
 *     dispatches by `chapter.layout` into one of the eleven reusable slide
 *     templates in `/slides/`.
 *
 * The keyed wrapper drives the per-chapter entrance animation. Because the
 * surrounding chrome (logo, progress dots, controls) never re-mounts, the
 * investor experiences a continuous reveal rather than a page transition.
 */
export const ChapterStage = ({ chapter, interceptorRef, ctx }) => {
  if (!chapter) return null;

  if (chapter.custom === "opening") {
    return <OpeningChapter chapter={chapter} interceptorRef={interceptorRef} />;
  }

  return (
    <div
      key={chapter.id}
      data-testid={`chapter-${chapter.id}`}
      data-chapter-layout={chapter.layout}
      className="w-full"
    >
      <NarrativeChapter chapter={chapter} ctx={ctx} />
    </div>
  );
};

export default ChapterStage;
